import { AppPages, VendorContactRole } from '@trnsact/trnsact-shared-types';
import { vendorContactRoleHumanReadable } from 'utils';
import { RoutingAccessPortalConfiguration } from '../types';

export const routingAccessDefaultConfig: RoutingAccessPortalConfiguration = {
  accessByPage: {
    [AppPages.AftermarketProducts]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.CompanyProfile]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.FinancePrograms]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.Inventory]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.LenderManagement]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.LocationManagement]: {
      rolesSettings: {
        hidden: [VendorContactRole.SalesRep],
      },
    },
    [AppPages.PortalSetup]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.PrescreenTools]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.UserManagement]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.WebsiteIntegrations]: {
      rolesSettings: {
        hidden: [VendorContactRole.SalesRep],
      },
    },
  },
};

export const APP_PAGES_ORDER: AppPages[] = [
  AppPages.CompanyProfile,
  AppPages.UserManagement,
  AppPages.LenderManagement,
  AppPages.FinancePrograms,
  AppPages.LocationManagement,
  AppPages.PortalSetup,
  AppPages.AftermarketProducts,
  AppPages.Inventory,
  AppPages.WebsiteIntegrations,
  AppPages.PrescreenTools,
];

export const APP_PAGES_LABELS: Record<AppPages, string> = {
  [AppPages.CompanyProfile]: 'Company Profile',
  [AppPages.UserManagement]: 'User Management',
  [AppPages.LenderManagement]: 'Lender Management',
  [AppPages.FinancePrograms]: 'Finance Programs',
  [AppPages.LocationManagement]: 'Location Management',
  [AppPages.PortalSetup]: 'Portal Setup',
  [AppPages.AftermarketProducts]: 'Aftermarket Products',
  [AppPages.Inventory]: 'Inventory',
  [AppPages.WebsiteIntegrations]: 'Website Integration',
  [AppPages.PrescreenTools]: 'Prescreen Tools',
};

export type RoleColumnConfig = { role: VendorContactRole; label: string };

export const ROLE_COLUMNS: RoleColumnConfig[] = [
  VendorContactRole.Admin,
  VendorContactRole.SalesMgr,
  VendorContactRole.SalesRep,
  VendorContactRole.FinanceMgr,
  VendorContactRole.CreditMgr,
  VendorContactRole.Executive,
  VendorContactRole.SupportPerson,
].map(role => ({ role, label: vendorContactRoleHumanReadable[role] }));
